{
  "SitePageTemplateSettings": {
    "ActionMenuLabel": "Available actions"
  },
  "components": {
    "AppLanguageSelector": {
      "toggleLanguageSwitcher": "Open/close language menu"
    },
    "BannerTitle": {
      "BannerBlockTitleAlignmentSelector": {
        "ActionMenuLabel": "Velg tekstjustering"
      },
      "BannerBlockTitleSizeSelector": {
        "ActionMenuLabel": "Velg tekststørrelse"
      },
      "BannerBlockTitleTransformationSelector": {
        "ActionMenuLabel": "Velg teksttransformasjon"
      },
      "BannerBlockTitleVerticalAlignmentSelector": {
        "ActionMenuLabel": "Velg vertikal tekstjustering"
      },
      "BannerBlockTitleWeightSelector": {
        "ActionMenuLabel": "Velg fonttykkelse"
      }
    },
    "CardEditor": {
      "Category": "Select category",
      "Skin": "Select color"
    },
    "CommonBlockContent": {
      "Alignment": {
        "ActionMenuLabel": "Select text alignment"
      }
    },
    "EditorBreadcrumbs": {
      "Description": "The full path to this page"
    },
    "EditorHeader": {
      "CreatePage": "Create new page",
      "GoBack": "Go back"
    },
    "EditorPreviewContainer": {
      "AdditionalActions": "Additional actions for preview",
      "SelectDeviceType": "Select device type for preview"
    },
    "EditorSectionActionButton": {
      "ActionMenuLabel": "Available actions"
    },
    "EditorView": {
      "Tabs": "Categories of content you can edit"
    },
    "FilterMenu": {
      "MenuLabel": "Change what pages to show"
    },
    "FinderLayout": {
      "CloseFinder": "Close finder",
      "ToggleFiltersOpen": "Open/Close filter section"
    },
    "Header": {
      "navigateToHome": "Go to home",
      "toggleMenuButton": "Open/close menu"
    },
    "ListView": {
      "AddRemoveAsFavourite": "Add/remove from favourites",
      "SelectOrDeselect": "Select or deselect item"
    },
    "MainLayout": {
      "ToggleMenu": "Expand/Contract menu"
    },
    "PageBlockArticleTitleBlockTextAlignSetting": {
      "ActionMenuLabel": "Select text alignment"
    },
    "PageBlockBannerLayoutSetting": {
      "ActionMenuLabel": "Select layout"
    },
    "PageBlockBannerSizeSetting": {
      "ActionMenuLabel": "Select size"
    },
    "PageBlockCardModuleViewSetting": {
      "ActionMenuLabel": "Select view type"
    },
    "PageBlockCollapsibleStateSetting": {
      "ActionMenuLabel": "Select collapsible state"
    },
    "PageBlockLayoutSetting": {
      "ActionMenuLabel": "Select layout"
    },
    "PageBlockLinkListViewSetting": {
      "ActionMenuLabel": "Select view type"
    },
    "PageBlockModuleLayoutSetting": {
      "ActionMenuLabel": "Select module layout"
    },
    "PageBlockModuleTypeSetting": {
      "ActionMenuLabel": "Select module type"
    },
    "PageBlockPageListLayoutSetting": {
      "ActionMenuLabel": "Select layout"
    },
    "PageBlockPositionSetting": {
      "ActionMenuLabel": "Select position"
    },
    "PageBlockTextPositionSetting": {
      "ActionMenuLabel": "Select text alignment"
    },
    "PageBlockTextSizeSetting": {
      "ActionMenuLabel": "Select text size"
    },
    "PageTree": {
      "ImportedPageTreeDescription": "Hierarchy of imported pages in the {{siteName}} site waiting for placement",
      "PageTreeDescription": "Hierarchy of all pages in the {{siteName}} site"
    },
    "PageTreeActionMenu": {
      "MenuDescription": "Available actions for the page \"{{pageName}}\""
    },
    "PageTreeFilter": {
      "ClearAllFilters": "Clear all filters",
      "ClearQuery": "Clear search"
    },
    "SearchSelector": {
      "SearchFieldLabel": "Search"
    },
    "SectionDirectionSelector": {
      "ActionMenuLabel": "Select the direction of the section content"
    },
    "SectionDraggingPlaceholder": {
      "Label": "This is a placeholder of the section being moved"
    },
    "SectionDropIndicator": {
      "Label": "This indicates where the section will be placed"
    },
    "SectionWidthSelector": {
      "ActionMenuLabel": "Select the width of the section"
    },
    "SideMenuLayout": {
      "closeMenuButton": "Close menu"
    },
    "SkinSelector": {
      "SelectSkinTooltip": "Select skins"
    },
    "SortMenu": {
      "MenuLabel": "Choose how pages are sorted"
    },
    "SplitButton": {
      "ShowAllOptions": "Show all options"
    },
    "UserAvatarMenu": {
      "toggleUserMenu": "Open/Close user menu"
    }
  },
  "preview": {
    "PreviewWrapper": {
      "ToggleDeveloperPreview": "Toggle developer preview"
    }
  }
}
